export const firstMessage = (message,webhookUrl,sessionId, sessionName) => {
    const sendMessages = async () => {
        const combinedMessage = `system: You are an AI assistant. The content of the 'first_message' variable should be taken as the start of our conversation and treated as your initial understanding of our communication context. Treat it as though it was the first message you received. You should then proceed normally.
    first_message: ${message}`;
        const formData = new FormData();
        formData.append('chatInput', combinedMessage);
        formData.append('session_id', sessionId);
        formData.append('session_name', sessionName? sessionName : 'main');

        await fetch(webhookUrl, { 
            method: 'POST',
            body: formData,
        });

        return true;
    }
    sendMessages();
};
